import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row } from "react-bootstrap";
import { MdDirectionsBus } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec",
  ];
  return `${String(date.getDate()).padStart(2, "0")} ${
    months[date.getMonth()]
  } ${date.getFullYear()}`;
};

const RecentSearch = ({ cacheData }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ⭐ CLICK HANDLER → Navigate to buslisting
  const handleSearchClick = (item) => {
    const queryParams = new URLSearchParams({
      from: item.source || "",
      to: item.destination || "",
      cityId: item.sourceId || "",
      desId: item.destinationId || "",
      journeyDate: item.journeyDate || "",
    }).toString();

    navigate(`/buslisting?${queryParams}`);
  };

  const itemsToShow = isMobile ? 15 : 6;

  return (
    <>
      {cacheData.length > 0 && (
        <div className="flightBookingMainDiv">
          <h4 className="tripgo_title_recent hotel_recent_search">
            Recent Bus Search
          </h4>

          <Row>
            {/* 📱 Mobile View */}
            {isMobile ? (
              <Swiper slidesPerView={3} spaceBetween={5} className="recentSearchSwiper">
                {cacheData.slice(0, itemsToShow).map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="FlightBookingDel hotelBookingDel_recent"
                      onClick={() => handleSearchClick(item)}
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "10px",
                        background: "#fff",
                      }}
                    >
                      <div className="flightBookingtext">
                        <MdDirectionsBus style={{ marginRight: "5px" }} />
                         {item.source} → {item.destination}
                      </div>

                      {/* <div className="flightBookingMinText">
                        {item.source} → {item.destination}
                      </div> */}

                      <div className="flightBookingMinText">
                        {formatDate(item.journeyDate)}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              // 💻 Desktop View
              <div className="flightBookingSearch_recent">
                {cacheData.slice(0, itemsToShow).map((item, index) => (
                  <div
                    className="FlightBookingDel hotelBookingDel"
                    key={index}
                    onClick={() => handleSearchClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="flightBookingtext">
                      <MdDirectionsBus style={{ marginRight: "5px" }} />
                       {item.source} → {item.destination}
                    </div>

                    {/* <div className="flightBookingMinText">
                      {item.source} → {item.destination}
                    </div> */}

                    <div className="flightBookingMinText">
                      {formatDate(item.journeyDate)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Row>
        </div>
      )}
    </>
  );
};

export default RecentSearch;
